export default __webpack_public_path__ + "static/media/logo-256.719553b1.png";